// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2_Dge","header":"PatientBlock_header__4H0V5","label":"PatientBlock_label__2_gTf","option":"PatientBlock_option__2x24z"};